var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18764_30982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.64 9.19999C17.64 8.56298 17.583 7.94899 17.476 7.35999H9V10.841H13.844C13.7438 11.3916 13.5329 11.9161 13.2242 12.383C12.9155 12.8498 12.5154 13.2492 12.048 13.557V15.816H14.956C16.658 14.249 17.64 11.941 17.64 9.20099V9.19999Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00003 18.0001C11.43 18.0001 13.467 17.1941 14.956 15.8161L12.048 13.5571C11.242 14.0971 10.211 14.4171 9.00003 14.4171C6.65603 14.4171 4.67203 12.8331 3.96403 10.7061H0.957031V13.0381C1.70552 14.5297 2.85418 15.7838 4.27457 16.6601C5.69495 17.5364 7.33109 18.0003 9.00003 18.0001Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.964 10.706C3.77914 10.1562 3.68393 9.58014 3.682 9.00004C3.682 8.40704 3.784 7.83004 3.964 7.29404V4.96204H0.957C0.327662 6.21506 -5.6909e-05 7.59785 7.41243e-09 9.00004C7.41243e-09 10.452 0.348 11.827 0.957 13.038L3.964 10.706Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00003 3.58C10.321 3.58 11.508 4.034 12.44 4.925L15.022 2.345C13.463 0.891 11.426 1.34994e-07 9.00003 1.34994e-07C7.33109 -0.000288924 5.69495 0.463645 4.27457 1.33993C2.85418 2.21622 1.70552 3.47031 0.957031 4.962L3.96403 7.294C4.67203 5.163 6.65603 3.58 9.00003 3.58Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18764_30982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo2);
export default __webpack_public_path__ + "static/media/GoogleLogo2.fe6ce436a8f6645e51d99dc4ca8b77dd.svg";
export { ForwardRef as ReactComponent };